@if (isOpen) {
<div class="modal-overlay" role="dialog" aria-labelledby="modal-title" aria-modal="true">
  <div class="modal-box">
    <h3 id="modal-title">Icon Credits</h3>
    <mat-list>
      @for (credit of credits; track credit) {
        <mat-list-item  lines="2">
          <img matListItemAvatar [src]="credit.url" alt="{{credit.iconName}} icon" width="20px" height="20px"/>
          <span matListItemTitle>{{ credit.iconName }} icon</span>
          Created by <a [href]="credit.iconLink" target="_blank" rel="noopener noreferrer">
          <strong>{{ credit.iconCreator }}</strong> - {{ credit.iconSource }}</a>
        </mat-list-item>
      }
    </mat-list>
    <div class="modal-actions">
      <button mat-flat-button (click)="close()">Close</button>
    </div>
  </div>
</div>
}
